module.exports = __webpack_public_path__ + "img/9788980071937.b7de5e31.jpg";